import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOvalNone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 20,
	viewBox: "0 0 44 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 44,
			height: 20,
			rx: 10,
			fill: "#F3F3FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 14.2421L16.8606 4.43231L16 5.18486L17.5818 6.57787V11.4721C17.5818 11.9418 17.8182 12.3634 18.1879 12.657V13.607C18.1879 13.9005 18.4606 14.1407 18.7939 14.1407H19.4C19.7333 14.1407 20.0061 13.9005 20.0061 13.607V13.0733H24.8545V13.607C24.8545 13.9005 25.1273 14.1407 25.4606 14.1407H26.0667C26.097 14.1407 26.1212 14.13 26.1515 14.1247L27.1455 15L28 14.2421ZM19.703 12.0058C19.2 12.0058 18.7939 11.6482 18.7939 11.2052C18.7939 10.7623 19.2 10.4047 19.703 10.4047C20.2061 10.4047 20.6121 10.7623 20.6121 11.2052C20.6121 11.6482 20.2061 12.0058 19.703 12.0058ZM18.7939 8.80349V7.64532L20.1091 8.80349H18.7939ZM20.5091 6.13489L18.6606 4.50704C19.5455 4.0854 20.903 4 22.4303 4C25.1091 4 27.2788 4.26686 27.2788 6.13489V11.4721C27.2788 11.6589 27.2303 11.8297 27.1636 11.9951L23.5394 8.80349H26.0667V6.13489H20.5091Z",
			fill: "#AAAAAA"
		})
	]
});
const ForwardRef = forwardRef(SvgOvalNone);
export { ForwardRef as ReactComponent };
